var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { MultiSelectWrapperStyled, MultiSelectButtonStyled, MultiSelectItemWrapperStyled, MultiSelectItemStyled, RadioButtonWrapper, RadioButton, IconWrapperMultiSelectAnimation, HandlersMultiSelectWrapper, MultiSelectBodyItemWrapperStyled, } from './styled';
import Icon from '../Icon';
import Button from '../Button';
import getUniqueKey from '../utils/customKey';
const MultiSelect = (_a) => {
    var props = __rest(_a, []);
    const { disabled, open: openProps, placeholder, getOptionLabel, options, values: valuesProps = [], handleApply: handleApplyProps, handleCancel: handleCancelProps } = props, rest = __rest(props, ["disabled", "open", "placeholder", "getOptionLabel", "options", "values", "handleApply", "handleCancel"]);
    const [open, setOpen] = useState(openProps || false);
    const [values, setValues] = useState(valuesProps || []);
    const handleChange = (newValue) => {
        if (values.includes(newValue)) {
            setValues(values.filter((item) => item !== newValue));
        }
        else {
            setValues([...values, newValue]);
        }
    };
    const handleCancel = () => {
        setOpen(false);
        setValues(valuesProps || []);
        if (handleCancelProps)
            handleCancelProps();
    };
    const handleApply = () => {
        setOpen(false);
        if (handleApplyProps)
            handleApplyProps(values);
    };
    useEffect(() => {
        if (valuesProps !== null)
            setValues(valuesProps);
    }, [valuesProps]);
    useEffect(() => {
        if (openProps !== null && !disabled)
            setOpen(openProps);
    }, [openProps]);
    return (_jsxs(MultiSelectWrapperStyled, Object.assign({ disabled: disabled }, rest, { children: [_jsxs(MultiSelectButtonStyled, Object.assign({ disabled: disabled, "data-testid": "multiSelectButton", open: open, onClick: () => setOpen(!open) }, { children: [_jsx("p", { children: placeholder }), _jsx(IconWrapperMultiSelectAnimation, Object.assign({ open: open }, { children: _jsx(Icon, Object.assign({ name: "arrowDownSpecial" }, (open ? { color: '#0057B8' } : {}))) }))] })), _jsx(MultiSelectItemWrapperStyled, Object.assign({ open: open }, rest, { children: _jsxs(MultiSelectBodyItemWrapperStyled, { children: [options.map((item) => {
                            const label = getOptionLabel ? getOptionLabel(item) : `${item}`;
                            const checked = values.includes(item);
                            return (_jsxs(MultiSelectItemStyled, Object.assign({ "data-testid": "multiSelectItem", onClick: () => handleChange(item) }, { children: [_jsx(RadioButtonWrapper, Object.assign({ checked: checked, "data-testid": "multiSelectItemButton" }, { children: _jsx(RadioButton, { checked: checked }) })), _jsx("p", { children: label })] }), getUniqueKey()));
                        }), _jsxs(HandlersMultiSelectWrapper, { children: [_jsx(Button, Object.assign({ variant: "ghost", size: "small", onClick: handleCancel, "data-testid": "cancelMultiSelectButton" }, { children: "Cancelar" })), _jsx(Button, Object.assign({ size: "small", onClick: handleApply, "data-testid": "applyMultiSelectButton" }, { children: "Aplicar" }))] })] }) }))] })));
};
MultiSelect.defaultProps = {
    options: [],
    values: [],
    open: false,
    disabled: false,
};
export default MultiSelect;
//# sourceMappingURL=index.js.map